module.exports = __webpack_public_path__ + "static/media/bursts_18.3d6c48c3.svg";